import { z } from "zod";
import { TObjectBaseTDate } from "../base";
import { TDate } from "../common/date";

export const TProjectStatus = z.enum(["active", "completed", "archived"]);
export type IProjectStatus = z.infer<typeof TProjectStatus>;

export const TProject = z
  .object({
    name: z.string(),
    description: z.string(),
    propertyID: z.string(),
    status: TProjectStatus,
    startDate: TDate.optional(),
    endDate: TDate.optional(),
  })
  .extend(TObjectBaseTDate.shape);
export type IProject = z.infer<typeof TProject>;
